import $ from 'jquery';

// Code moved from src/scripts/entry-points/shoppingbag/index.js so limiting updates to maintain annotations
export default function showQuickView(event, codes, sbsrc, carouselType, callback) {
    var requestURL = window.location.href;
    var isMens = window.location.href.indexOf('d=Mens') != -1;
    var dParam = isMens? 'Mens' : 'Womens';
    var paramObj = {
        codes : codes,
        d : dParam,
        requestUrl : requestURL
    };
    if (sbsrc) {
        paramObj.sbsrc = sbsrc;
    }
    var data= $.param(paramObj);
    var $triggerTarget = $(event.currentTarget);

    $.modal({
        url: "/fw/ajax/multiItemQuickview.jsp",
        data: data,
        triggerOpen: true,
        returnFocus: $(event.currentTarget),
        onComplete : function () {
            if (typeof callback === 'function') {
                callback(carouselType, $triggerTarget);
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/quick-view.js